module.exports = __webpack_public_path__ + "static/logo-46187b3afa350cc3ae9e8fcff37a8d10.svg";